import {defineComponent} from 'vue'

export default defineComponent({
    name: 'addMemebr',
    data: () => {
        return {
            //
        }
    }
})